<template>
    <!-- Loading -->
    <div class="vld-parent">
        <loading v-model:active="isLoading" :is-full-page="true" :height="128" :width="128" />
    </div>

    <form @submit.prevent="store" class="form-content">

        <div class="form-content-inner">

            <div v-if="upload.submenu == 'Training'">
                <div class="form-col">
                    <control type="hidden" v-model="upload.id" :hasError="!!errors.id" id="id"/>
                </div>
                <div class="form-col">
                    <field :label="$t('candidate.submenu')" class="w-full md:w-2/2 px-3 mb-6 md:mb-0">
                        <control type="text" v-model="upload.submenu" readonly/>
                    </field>
                </div>
            </div>

            <div v-else>
                <div class="form-col">
                    <control type="hidden" v-model="upload.id" :hasError="!!errors.id" id="id"/>
                </div>
                <div class="form-col">
                    <field :label="$t('candidate.submenu')" class="w-full md:w-2/2 px-3 mb-6 md:mb-0">
                        <control :options="options" v-model="upload.submenu"/>
                    </field>
                </div>
            </div>

            <div>
                <div class="form-col">
                    <field :label="$t('vaccines.start_date')" class="w-full md:w-2/2 px-3 mb-6 md:mb-0 md:w-1/2">
                        <datepicker v-model="upload.start_date" :enableTimePicker="false" name="start_date" :auto-apply="true"></datepicker>
                    </field>
                    <field :label="$t('vaccines.end_date')" class="w-full md:w-2/2 px-3 mb-6 md:mb-0 md:w-1/2">
                        <datepicker v-model="upload.end_date" :enableTimePicker="false" name="end_date" :auto-apply="true"></datepicker>

                    </field>
                </div>

                <div class="form-col">
                    <field :label="$t('vaccines.description')" class="w-full md:w-2/2 px-3 mb-6 md:mb-0">
                        <control type="text" :placeholder="$t('vaccines.placeholder.description')" v-model="upload.description"/>
                    </field>
                </div>

                <div class="form-col" v-if="upload.submenu == 'Training'">
                    <field :label="$t('vaccines.assignment_no')" class="w-full md:w-2/2 px-3 mb-6 md:mb-0">
                        <control type="text" v-model="upload.assignment_no"/>
                    </field>
                </div>

                <div class="form-col" v-else>
                    <field :label="$t('lessonplan.file')" class="w-full md:w-2/2 px-3 mb-6 md:mb-0">
                        <input type="file" accept="application/pdf" v-on:change="onFileChange" class="form-control-file" id="idcardFile">
                    </field>
                </div>

                <div class="form-col" v-if="upload.submenu == 'Training'">
                    <field :label="$t('vaccines.assignment_file')" class="w-full md:w-2/2 px-3 mb-6 md:mb-0">
                        <input type="file" accept="application/pdf" v-on:change="onFileChange" class="form-control-file" id="idcardFile">
                    </field>
                </div>

                <div class="form-col" v-if="upload.submenu == 'Training'">
                    <field :label="$t('vaccines.certificate_no')" class="w-full md:w-2/2 px-3 mb-6 md:mb-0">
                        <control type="text" v-model="upload.certificate_no"/>
                    </field>
                </div>

                <div class="form-col" v-if="upload.submenu == 'Training'">
                    <field :label="$t('vaccines.certificate_exp_date')" class="w-full md:w-2/2 px-3 mb-6 md:mb-0">
                        <control type="datetime-local" v-model="upload.certificate_exp_date"/>
                    </field>
                </div>

                <div class="form-col" v-if="upload.submenu == 'Training'">
                    <field :label="$t('vaccines.certificate_file')" class="w-full md:w-2/2 px-3 mb-6 md:mb-0 mt-5">
                        <input type="file" accept="application/pdf" v-on:change="onFileChangeCertificate" class="form-control-file" id="my-file-certificate">
                    </field>
                </div>
            </div>

            <div class="buttons-submit transition-colors duration-1000" :class="darkMode ? 'bg-darkmode-base' : 'bg-gray-100'">
                <jb-buttons class="buttons-action-submit">
                    <jb-button type="submit" color="info" :icon="mdiCheckBold" :label="$t('finance.button.btnSubmit')" class="form-submit-btn" />
                    <jb-button type="button" color="info" outline :label="$t('finance.button.btnReset')" class="form-noicon-btn btn-reset" @click="reset()" />
                </jb-buttons>
            </div>
        </div>
    </form>
</template>
<script>
/* eslint-disable */
import { ref, reactive, onMounted, onBeforeMount, watch, watchEffect } from 'vue'
import { axiosDocument } from "@/boot/axios";
import axios from 'axios'
import { mdiBallot, mdiCheckBold } from '@mdi/js'
import { useStore } from 'vuex'
import Control from '@/components/Control'
import { useRouter } from 'vue-router'
import JbButton from '@/components/JbButton'
import JbButtons from '@/components/JbButtons'
import Field from '@/components/Field'
import { useToast } from 'vue-toastification'
import Loading from 'vue-loading-overlay'
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main\.css'
export default {
    name: 'ClassForm',
    components: {
        Field,
        Control,
        JbButton,
        JbButtons,
        Loading,
        Datepicker
    },
    props: {
        showEdit: { Boolean },
        propClass: {
            type: Object,
            default: () => ({ empty: true })
        },
        propObject: {
            type: Object,
            default: () => ({ empty: true })
        }
    },
    data: function () {
        return {
        }
    },
    emits: ['close-modal', 'submit', 'refresh-list'],
    setup (props, { emit }) {
        const titleStack = ref(['Admin', 'Forms'])
        const isLoading = ref(false)

        const toast = useToast()

        const router = useRouter()

        const errors = ref([])
        const options = [
            {id: 'ID Card', name: 'ID Card'},
            {id: 'Family Card', name: 'Family Card'},
            {id: 'Passport', name: 'Passport'},
            {id: 'Tax ID Card', name: 'Tax ID Card'},
            {id: 'Insurance Card', name: 'Insurance Card'},
            {id: 'Driving License', name: 'Driving License'}
        ]
        const preview = ref('')
        const preview_certificate = ref('')

        const str = useStore()
        const userlogin = localStorage.getItem('name')

        const upload = reactive({
            id: '',
            submenu: '',
            start_date: '',
            end_date: '',
            certificate_no: '',
            certificate_exp_date: '',
            certificate_file: '',
            description: '',
            file: '',
            assignment_no: '',
            created_by: '',
            updated_by: ''
        })

        const customElementsForm = reactive({
            checkbox: ['lorem'],
            radio: 'one',
            is_active: [1],
            file: null
        })

        const onFileChange = async (event, evt) => {
            const file = event.target.files[0]
            if (file) {
                if (file.type !== 'application/pdf') {
                    alert('Only PDF files are allowed');
                    event.target.value = ''
                } else if (file.size > 1024 * 1024) {
                    alert('File too big (> 1MB)')
                    file.value = ''
                } else {
                    const reader = new FileReader()
                    reader.onloadend = function () {
                        preview.value = reader.result
                    }
                    reader.readAsDataURL(file)
                }
            } else {
                preview.value = '';
            }
            console.log('onFileChange', preview.value);
        };

        const onFileChangeCertificate = async (event, evt) => {
            const fileCertificate = event.target.files[0]
            if (fileCertificate) {
                if (fileCertificate.type !== 'application/pdf') {
                    alert('Only PDF files are allowed');
                    event.target.value = ''
                }
                else if (fileCertificate.size > 1024 * 1024) {
                    alert('File too big (> 1MB)')
                    fileCertificate.value = ''
                } else {
                    const readerCertificate = new FileReader()
                    readerCertificate.onloadend = function () {
                        preview_certificate.value = readerCertificate.result
                    }
                    readerCertificate.readAsDataURL(fileCertificate)
                }
            } else {
                preview_certificate.value = ''
            }
            console.log('onFileChangeCertificate', preview_certificate.value)
        }

        const store = async () => {
            isLoading.value = true
            const url = props.showEdit ? 'employeeattachment/' + upload.id : 'employeeattachment';
            const method = props.showEdit ? "PUT" : "POST";

            upload.created_by = userlogin
            upload.file = preview.value
            upload.certificate_file = preview_certificate.value
            console.log('upload', upload)
            // console.log('upload.certificate_file', upload.certificate_file)

            const jsonData = JSON.stringify(upload)

            const configHeaders = {
                "content-type": "application/json",
                "Accept": "application/json"
            };

            await axios({
                    method,
                    url,
                    data: jsonData,
                    headers: configHeaders
                })
                .then(response => {
                    if(response.data.is_doc > 0 && upload.file != ''){
                        storeDoc(response.data.link_doc)
                    } else {
                        if (response.data.success) {
                            emit('close-modal')
                            emit('refresh-list')
                            toast.success(response.data.message)
                        } else {
                            errors.value = response.data.messages
                            toast.error(response.data.messages)
                        }
                        isLoading.value = false
                    }
                })
                .catch(error => {
                    if (error.response) {
                        console.log(error)
                        toast.error(error.response.data.message)
                        console.log(JSON.stringify(error.request))
                    } else if (error.message) {
                        console.log(error.message)
                        toast.error(error.message)
                        console.log(JSON.stringify(error.message))
                    }
                    isLoading.value = false
                })
        }

        // if doc academic active = true
        const storeDoc = (env) => {
            const url = 'doc-file-employee'
            const method = 'POST'

            isLoading.value = true
            const paramsData = {
                link_doc: env
            }
            const jsonData = JSON.stringify(paramsData)
            console.log('paramsData DOC', paramsData)

            const configHeaders = {
                'content-type': 'application/json',
                Accept: 'application/json'
            }

            axiosDocument({
                method,
                url,
                data: jsonData,
                headers: configHeaders
            })
            .then(response => {
                isLoading.value = false
                emit('close-modal')
                emit('refresh-list')
                toast.success(response.data.message)
            })
            .catch(error => {
                isLoading.value = false
                console.log('error', error)
            })
        }

        onBeforeMount(() => {
        })

        onMounted(() => {
            // upload.value =toRefs(props, 'propClass')
        })

        watch(() => props.propClass, (newVal, oldVal) => {
            upload.file = ''
            upload.description = ''
        })

        // watch(() => upload.submenu, (newVal, oldVal) => {
        //     console.log('upload.submenu', upload.submenu)
        // })

        watchEffect(() => {
            const newobject = props.propObject;
            Object.assign(upload, newobject);

            if (!props.showEdit) {
                upload.id = null;
                upload.start_date = null;
                upload.end_date = null;
                upload.certificate_no = null;
                upload.certificate_exp_date = null;
                upload.certificate_file = null;
                upload.description = null;
                upload.file = null;
                upload.assignment_no = null;
            }

            const newupload = props.propClass
            upload.ein = newupload.ein
            upload.employee_id = newupload.employee_id
            upload.nickname = newupload.nickname

            if (upload.submenu == ''){
                upload.submenu = newupload.submenu
                if(newupload.submenu == ''){
                    upload.submenu = newobject.submenu
                }
            }
        })

        return {
            titleStack,
            onFileChange,
            onFileChangeCertificate,
            customElementsForm,
            mdiBallot,
            mdiCheckBold,
            options,
            router,
            upload,
            store,
            toast,
            userlogin,
            errors,
            isLoading
        }
    },
    methods: {
        // async store () {
        //     const dataForm = {
        //         id: this.upload.id,
        //         name: this.upload.name,
        //         academic_year_id: this.upload.academic_year_id,
        //         capacity: this.upload.capacity,
        //         homeroom_id: this.upload.homeroom_id ?? this.upload.level_id,
        //         is_active: this.customElementsForm.is_active ?? false,
        //         remarks: this.upload.remarks,
        //         level_id: this.upload.level_id,
        //         department_id: this.upload.department_id,
        //         remarks1: this.upload.remarks1,
        //         remarks2: this.upload.remarks2,
        //         remarks3: this.upload.remarks3,
        //         created_by: 'admin',
        //         updated_by: this.upload.updated_by
        //     }
        //     // await axios
        //     //     .post('class', dataForm)
        //     //     .then(response => {
        //     //         if (response.data.success) {
        //     //         } else {
        //     //             this.errors = response.data.messages
        //     //         }
        //     //     })
        //     //     .catch(error => {
        //     //         if (error.response) {
        //     //             console.log(error)
        //     //             console.log(JSON.stringify(error.request))
        //     //         } else if (error.message) {
        //     //             console.log(error.message)
        //     //             console.log(JSON.stringify(error.message))
        //     //         }
        //     //     })
        // },
        clearForm () {
            this.upload = reactive({
                id: '',
                description: '',
                created_by: ''
            })
        },
        onChange: function (department_id, event) {
            if (event.target.value) {
                department_id = event.target.value
            }
            this.levelListFilter = this.levelList.filter(item => item.department_id === department_id)
            this.academicYearListFilter = this.academicYearList.filter(item => item.department_id === department_id)
        }
    },
    created () {
        this.levelListFilter = this.levelList
        this.academicYearListFilter = this.academicYearList
    }
}
</script>
